export const CLEANUP_PASSWORD_RECOVERY_STATE = 'cleanup-password-recovery-state';
const cleanupPasswordRecoveryState = () => ({ type: CLEANUP_PASSWORD_RECOVERY_STATE });
export default cleanupPasswordRecoveryState;
